import produce from 'immer';
import { ADD_VERSION_REQUEST, ADD_VERSION_SUCCESS, ADD_VERSION_FAILURE, GET_CHANGELOG_REQUEST, GET_CHANGELOG_SUCCESS, GET_CHANGELOG_FAILURE, GET_VERSION_DETAILS_REQUEST, GET_VERSION_DETAILS_SUCCESS, GET_VERSION_DETAILS_FAILURE, } from './constants';
export var initialState = {
    error: false,
    saving: false,
    changeLogError: false,
    loading: false,
    changeLog: {},
    latestVersion: {},
    latestVersionLoading: false,
};
function versionNewReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case ADD_VERSION_REQUEST:
                state.saving = true;
                state.error = false;
                break;
            case ADD_VERSION_SUCCESS:
                state.saving = false;
                state.error = false;
                break;
            case ADD_VERSION_FAILURE:
                state.saving = false;
                state.error = true;
                break;
            case GET_CHANGELOG_REQUEST:
                state.loading = true;
                state.changeLogError = false;
                state.changeLog = [];
                break;
            case GET_CHANGELOG_SUCCESS:
                state.loading = false;
                state.changeLogError = false;
                state.changeLog = action.logs || {};
                break;
            case GET_CHANGELOG_FAILURE:
                state.loading = false;
                state.changeLogError = true;
                break;
            case GET_VERSION_DETAILS_REQUEST:
                state.latestVersionLoading = true;
                state.error = false;
                break;
            case GET_VERSION_DETAILS_SUCCESS:
                state.latestVersionLoading = false;
                state.latestVersion = action.version || {};
                break;
            case GET_VERSION_DETAILS_FAILURE:
                state.latestVersionLoading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default versionNewReducer;
